import React from 'react'
import clsx from 'clsx'
import { graphql, useStaticQuery } from 'gatsby'
import BlogCard from '../../components/BlogCard/BlogCard'

export const FeaturedBlogs = ({ otherClasses }) => {
  const featuredBlogsClasses = clsx(
    otherClasses,
    'max-w-[1512px] px-6 lg:px-20 xl:px-[156px] mx-auto w-full grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10 mb-16 lg:mb-[120px] mt-10 lg:mt-[125px]'
  )

  const {
    allSanityBlogs: { nodes },
  } = useStaticQuery(graphql`
    query featuredBlogsPostQuery {
      allSanityBlogs(limit: 3, filter: { featured: { eq: true } }) {
        nodes {
          slug {
            current
          }
          mobileImage {
            ...CustomImage
          }
          blogCategory {
            category
          }
          title
        }
      }
    }
  `)

  return (
    <section className={featuredBlogsClasses} data-testid="featured-blogs">
      {nodes.map((nodes, index) => {
        return <BlogCard key={index} {...nodes} />
      })}
    </section>
  )
}

export default FeaturedBlogs
